import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import moment from 'moment';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { DateFromTo } from 'components/atoms/date-from-to';
import { humanise } from 'components/atoms/humanised-date';
const HolidatContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: var(--spacing-03) 0;
  min-width: 100px;
`;
const DateValue = styled.div`
  display: flex;
`;
const DateStyle = styled.div`
  font-weight: var(--heading-8-weight);
  margin-right: var(--spacing-02);
`;
const HolidayText = styled.div`
  font-style: italic;
`;
const renderer = (holidayValue)=>{
    if (holidayValue.holidayStart === '' && holidayValue.holidayEnd === '') {
        return null;
    }
    if (holidayValue.holidayStart === holidayValue.holidayEnd) {
        return /*#__PURE__*/ _jsx(DateStyle, {
            children: humanise(moment(holidayValue.holidayEnd))
        });
    }
    return /*#__PURE__*/ _jsx(DateStyle, {
        children: /*#__PURE__*/ _jsx(DateFromTo, {
            from: moment(holidayValue.holidayStart),
            to: moment(holidayValue.holidayEnd)
        })
    });
};
const TootltipContent = ({ holiday })=>{
    const { holidayName } = holiday;
    return /*#__PURE__*/ _jsxs(HolidatContainer, {
        children: [
            /*#__PURE__*/ _jsxs(DateValue, {
                children: [
                    renderer(holiday),
                    "(",
                    /*#__PURE__*/ _jsx(FormattedMessage, {
                        id: "holiday"
                    }),
                    ")"
                ]
            }),
            /*#__PURE__*/ _jsxs(HolidayText, {
                children: [
                    '"',
                    holidayName,
                    '"'
                ]
            })
        ]
    });
};
export const GetHolidayTooltipContent = ({ holiday })=>{
    if (!holiday) {
        return null;
    }
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: holiday.map((holidayValue)=>/*#__PURE__*/ _jsx(TootltipContent, {
                holiday: holidayValue
            }, holidayValue === null || holidayValue === void 0 ? void 0 : holidayValue.holidayId))
    });
};
